import { Routes } from '@angular/router';
import { WelcomeComponent } from './home/welcome.component';
import { LoginFormComponent } from './account/login-form/login-form.component';
import { SsoComponent } from './account/sso/sso.component';
import { AccountGuardService } from './account/shared/account-guard.service';
import { HomeResolver } from './home/home-resolver.service';
import { TileSecurityResolver } from './config/security.resolver.service';

export const routes: Routes = [
  { path: 'welcome', component: WelcomeComponent },
  { path: 'login', component: LoginFormComponent },
  { path: 'sso', component: SsoComponent },
  {
    path: 'dashboard',
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
    canActivate: [AccountGuardService],
    resolve: { latestChanges: HomeResolver }
  },
  {
    path: 'tilesecurity',
    loadComponent: () => import('./config/tile-security.component').then(m => m.TileSecurityComponent),
    canActivate: [AccountGuardService],
    resolve: { tileUsers: TileSecurityResolver }
  },
  {
    path: 'security',
    loadComponent: () => import('./config/security.component').then(m => m.SecurityComponent),
    canActivate: [AccountGuardService],
    resolve: { tileUsers: TileSecurityResolver }
  },
  {
    path: 'insights',
    loadComponent: () => import('./insights/insight-container.component').then(m => m.InsightContainerComponent),
    canActivate: [AccountGuardService]
  },
  {
    path: 'configuration',
    loadComponent: () => import('./config/unified/unified-config.component').then(m => m.UnifiedConfigComponent),
    canActivate: [AccountGuardService],
    resolve: { tileUsers: TileSecurityResolver }
  },
  {
    path: 'exports',
    loadComponent: () => import('./exports/export-list.component').then(m => m.ExportListComponent),
    canActivate: [AccountGuardService]
  },
  {
    path: 'exports/new',
    loadComponent: () => import('./exports/export-new.component').then(m => m.ExportNewComponent),
    canActivate: [AccountGuardService]
  },
  {
    path: 'billing',
    loadComponent: () => import('./billing/billing.component').then(m => m.BillingComponent),
    canActivate: [AccountGuardService]
  },
  {
    path: 'updates',
    loadComponent: () => import('./app-updates/functionality-updates/functionality-updates.component').then(m => m.FunctionalityUpdatesComponent),
    canActivate: [AccountGuardService]
  },
  { path: '', redirectTo: 'welcome', pathMatch: 'full' },
  { path: '**', redirectTo: 'welcome', pathMatch: 'full' }
];
